const getAssignedSupportInfo = (supportId, supportName) => {
  return {
    id: supportId,
    name: supportName,
  }
}

export default getAssignedSupportInfo;